import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdateKanbanTicket } from '../services/patchUpdateKanbanTicket.service';

export const updateKanbanTicket = createAsyncThunk(
  'kanban/updateKanbanTicket',
  async ({ projectId, ticketId, updates }) => {
    const updatedTicket = await patchUpdateKanbanTicket(
      projectId,
      ticketId,
      updates
    );
    return updatedTicket;
  }
);
